import React from 'react';
import Img_logo from '../images/construction.jpg';

export default () => (
	<div className='section2-CN'>

		<div class="service-split">
			<img class="service-split-img" src={Img_logo}></img>
			<div>
				<h4>
					Construction
				</h4>

				<p>
					12. Construction Management & Oversight:
					As the building goes up, we monitor progress, quality, and cost… dealing with issues as they arise, keeping you informed, and making sure decisions stay grounded in the bigger picture.
				</p>
				<p>
					13. Inspections & Code Compliance:
					We coordinate required inspections and ensure the work meets building code, fire, and municipal standards so you can actually occupy and operate the building.
				</p>
				<p>
					14. Completion, Turnover & Move-In Readiness:
					Once construction wraps, we oversee final fixes, documentation, and handover… making sure suites, common areas, and building systems are ready for residents.
				</p>

			</div>
		</div>

	</div>
);
